import { CAMPAIGNS_API } from 'modules/campaigns/api/constants'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { CampaignInterface } from '../types/campaign-interface'

export const useUpdateSenderEmailAddress = () => {
  const { fetcher } = useFetch<RequestMethodsEnum.put, CampaignInterface['senderEmailAddress']>({
    method: RequestMethodsEnum.put,
  })
  return {
    updateSenderEmailAddress: (
      id: number,
      senderEmailAddress: CampaignInterface['senderEmailAddress'],
    ) =>
      fetcher(`${CAMPAIGNS_API}/${id}/sender-email-address`, {
        senderEmailAddress: senderEmailAddress,
      }),
  }
}
